'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_STATUS_FOR_ARCHIVED_SEARCH = exports.DEFAULT_STATUS_FOR_ONLINE_SEARCH = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _has = require('babel-runtime/core-js/reflect/has');

var _has2 = _interopRequireDefault(_has);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.getSearchParams = getSearchParams;
exports.parameterNameFromFacetId = parameterNameFromFacetId;
exports.getFacetFromSearchQueryParameter = getFacetFromSearchQueryParameter;
exports.resetPageNumber = resetPageNumber;
exports.addValueToParamsList = addValueToParamsList;
exports.removeParamsFromList = removeParamsFromList;
exports.removeCampaignId = removeCampaignId;
exports.removeCountry = removeCountry;
exports.removeDistance = removeDistance;
exports.modifyUrlWhenChecked = modifyUrlWhenChecked;
exports.addRangeToParams = addRangeToParams;
exports.modifyUrlWithSearchStatus = modifyUrlWithSearchStatus;
exports.modifyUrlWithRange = modifyUrlWithRange;
exports.modifyUrlWithTaxonomy = modifyUrlWithTaxonomy;
exports.taxonomyParentSelected = taxonomyParentSelected;
exports.taxonomyAllSelected = taxonomyAllSelected;
exports.modifyUrlWhenPageChanges = modifyUrlWhenPageChanges;
exports.removeCountryAndDistance = removeCountryAndDistance;
exports.modifyUrlWithDistance = modifyUrlWithDistance;
exports.modifyUrlWithSort = modifyUrlWithSort;
exports.removeFacetById = removeFacetById;
exports.removeUpcomingFacetFromUrl = removeUpcomingFacetFromUrl;
exports.removeArchiveFacetFromUrl = removeArchiveFacetFromUrl;
exports.clearAllParamsExceptCategoriesForCategoryPage = clearAllParamsExceptCategoriesForCategoryPage;
exports.clearAllParamsExceptCategories = clearAllParamsExceptCategories;

var _search = require('../redux/modules/search');

var _urls = require('../utils/urls');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _facetTypes = require('./search/facetTypes');

var _facetTypes2 = _interopRequireDefault(_facetTypes);

var _url2 = require('../utils/url');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _paramTypes = require('./search/paramTypes');

var _paramTypes2 = _interopRequireDefault(_paramTypes);

var _searchDisplayTypes = require('../enums/searchDisplayTypes');

var _searchDisplayTypes2 = _interopRequireDefault(_searchDisplayTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_STATUS_FOR_ONLINE_SEARCH = exports.DEFAULT_STATUS_FOR_ONLINE_SEARCH = 'online';
var DEFAULT_STATUS_FOR_ARCHIVED_SEARCH = exports.DEFAULT_STATUS_FOR_ARCHIVED_SEARCH = 'archive';

function getSearchParams(location) {
    if (!location) {
        return {};
    }

    var searchParams = location.search ? (0, _url2.getParams)(location.search) : {};
    if (searchParams.parameters) {
        var param = JSON.parse(searchParams.parameters);
        searchParams = (0, _extends3.default)({}, searchParams, param);
        delete searchParams.parameters;
    }
    if (searchParams.campaignId || location.query.campaign_id) {
        searchParams.campaign_id = searchParams.campaignId || location.query.campaign_id;
        if (searchParams.campaignId) {
            delete searchParams.campaignId;
        }
    }

    if (searchParams.buyNow || location.query.buyNow) {
        searchParams.buyNow = searchParams.buyNow || location.query.buyNow;
    }

    if (searchParams.buyNowDate || location.query.buyNowDate) {
        searchParams.buyNowDate = searchParams.buyNowDate || location.query.buyNowDate;
    }

    if (searchParams.category_id) {
        searchParams.category_id = searchParams.category_id.toString();
    }
    if (searchParams.page) {
        searchParams.page = parseInt(searchParams.page, 10);
    }

    return searchParams;
}

function parameterNameFromFacetId(facetId) {
    var paramName = '';
    if (facetId === _facetTypes2.default.AUCTION_HOUSE_ID) {
        paramName = _paramTypes2.default.AUCTION_HOUSE_ID;
    } else if (facetId === _facetTypes2.default.MATERIALS_AND_TECHNIQUES_ID || facetId === _facetTypes2.default.CREATOR_ID || facetId === _facetTypes2.default.STYLE_PERIOD_ID || facetId === _facetTypes2.default.CATEGORY_ID || facetId === _facetTypes2.default.ORIGIN_ID) {
        paramName = _paramTypes2.default.CATEGORY_ID;
    } else if (facetId === _facetTypes2.default.COUNTRY_CODE_ID) {
        paramName = _paramTypes2.default.COUNTRY_CODE_ID;
    } else if (facetId === _facetTypes2.default.CURRENCY_ID) {
        paramName = _paramTypes2.default.CURRENCY_ID;
    } else if (facetId === _facetTypes2.default.CURRENT_BID_ID) {
        paramName = _paramTypes2.default.CURRENT_BID_ID;
    } else if (facetId === _facetTypes2.default.ESTIMATED_PRICE_ID) {
        paramName = _paramTypes2.default.ESTIMATED_PRICE_ID;
    } else if (facetId === _facetTypes2.default.HAMMER_PRICE_ID) {
        paramName = _paramTypes2.default.HAMMER_PRICE_ID;
    } else if (facetId === _facetTypes2.default.SALE_TYPE_ID) {
        paramName = _paramTypes2.default.SALE_TYPE_ID;
    }

    return paramName;
}

function getFacetFromSearchQueryParameter(paramKey) {
    var facetId = void 0;
    if (paramKey === _paramTypes2.default.AUCTION_HOUSE_ID) {
        facetId = _facetTypes2.default.AUCTION_HOUSE_ID;
    } else if (paramKey === _paramTypes2.default.COUNTRY_CODE_ID) {
        facetId = _facetTypes2.default.COUNTRY_CODE_ID;
    } else if (paramKey === _paramTypes2.default.CURRENCY_ID) {
        facetId = _facetTypes2.default.CURRENCY_ID;
    } else if (paramKey === _paramTypes2.default.ESTIMATED_PRICE_ID) {
        facetId = _facetTypes2.default.ESTIMATED_PRICE_ID;
    } else if (paramKey === _paramTypes2.default.CURRENT_BID_ID) {
        facetId = _facetTypes2.default.CURRENT_BID_ID;
    } else if (paramKey === _paramTypes2.default.DISTANCE_ID) {
        facetId = _facetTypes2.default.DISTANCE_ID;
    } else if (paramKey === _paramTypes2.default.HAMMER_PRICE_ID) {
        facetId = _facetTypes2.default.HAMMER_PRICE_ID;
    } else if (paramKey === _paramTypes2.default.SALE_TYPE_ID) {
        facetId = _facetTypes2.default.SALE_TYPE_ID;
    }
    return facetId;
}

function resetPageNumber(params) {
    var newParams = (0, _cloneDeep2.default)(params);
    delete newParams.page;
    return newParams;
}

function addValueToParamsList(params, paramName, value) {
    if (params[paramName]) {
        var ids = params[paramName].split(',');
        if (!ids.some(function (id) {
            return id === value;
        })) {
            ids.push(value);
            params[paramName] = ids.join(',');
        }
    } else {
        params[paramName] = value;
    }
}

function removeParamsFromList(params, paramName, value) {
    if ((0, _has2.default)(params, paramName)) {
        var values = params[paramName].split(',');
        var index = values.indexOf(value);
        if (index > -1) {
            values.splice(index, 1);
        }

        if (values.length === 0) {
            delete params[paramName];
        } else {
            params[paramName] = values.join(',');
        }
    }
}

function removeCampaignId(params) {
    removeParamsFromList(params, _paramTypes2.default.CAMPAIGN_ID, params.campaignId);
    return params;
}

function removeCountry(params) {
    removeParamsFromList(params, _paramTypes2.default.COUNTRY_CODE_ID, params.country);
    return params;
}

function removeDistance(params) {
    removeParamsFromList(params, _paramTypes2.default.DISTANCE_ID, params.distance);
    return params;
}

function modifyUrlWhenChecked(facetId, value, location, checked) {
    var params = getSearchParams(location);
    var paramName = parameterNameFromFacetId(facetId);
    if (checked) {
        addValueToParamsList(params, paramName, value);
        if (facetId === _facetTypes2.default.COUNTRY_CODE_ID) {
            removeDistance(params);
        }
    } else {
        removeParamsFromList(params, paramName, value);
    }
    return params;
}

function addRangeToParams(params, paramName, min, max) {
    var minValue = min !== '' && min !== undefined ? min : -1;
    var maxValue = max !== '' && max !== undefined ? max : -1;

    params[paramName] = 'USD:' + minValue + ':' + maxValue;
}

function modifyUrlWithSearchStatus(location, mode, sellerId) {
    var params = getSearchParams(location);

    (0, _keys2.default)(params).forEach(function (key) {
        if (key === _paramTypes2.default.KEYWORD || key === _paramTypes2.default.PAGE_SIZE_LEGACY_SUPPORT || key === _paramTypes2.default.PAGE_SIZE) return;

        delete params[key];
    });

    params[_paramTypes2.default.SORT] = _search.DEFAULT_SORT_ORDER;

    switch (mode) {
        case _searchDisplayTypes2.default.DISPLAY_AUCTION:
            params[_paramTypes2.default.STATUS] = DEFAULT_STATUS_FOR_ONLINE_SEARCH;
            break;
        case _searchDisplayTypes2.default.DISPLAY_BUY_NOW:
            params[_paramTypes2.default.STATUS] = DEFAULT_STATUS_FOR_ARCHIVED_SEARCH;
            params[_paramTypes2.default.BUY_NOW] = true;
            break;
        case _searchDisplayTypes2.default.DISPLAY_PRICE_RESULTS:
            params[_paramTypes2.default.STATUS] = DEFAULT_STATUS_FOR_ARCHIVED_SEARCH;
            break;
        default:
    }

    if (sellerId) {
        params['house_id'] = '' + sellerId;
    }

    return params;
}

function modifyUrlWithRange(facetId, location, min, max) {
    var params = getSearchParams(location);
    var paramName = parameterNameFromFacetId(facetId);

    addRangeToParams(params, paramName, min, max);

    return params;
}

var concatenatePath = function concatenatePath(category, catId) {
    if (!category) return '';
    if (category.id === catId) {
        return category.id;
    }
    var nextCategory = (0, _search.findCategoryContainingSomeCategoryId)(catId, category.categories);
    return [category.id].concat((0, _toConsumableArray3.default)(concatenatePath(nextCategory, catId)));
};

function modifyUrlWithTaxonomy(facetId, value, location, facets) {
    var params = getSearchParams(location);
    var paramName = parameterNameFromFacetId(facetId);
    var treeFacets = facets.filter(function (category) {
        return category.id === facetId;
    });

    var result = (0, _search.findCategoryContainingSomeCategoryId)(value, treeFacets);

    var numbersToRemove = concatenatePath(result, value);
    if (numbersToRemove && numbersToRemove.length > 0) {
        numbersToRemove.forEach(function (idToRemove) {
            if (idToRemove !== facetId || idToRemove !== value) {
                removeParamsFromList(params, paramName, idToRemove);
            }
        });
    }
    addValueToParamsList(params, paramName, value);
    return params;
}

function taxonomyParentSelected(parentId, categoryId, facetId, location) {
    var params = getSearchParams(location);
    var paramName = parameterNameFromFacetId(facetId);
    removeParamsFromList(params, paramName, categoryId);
    addValueToParamsList(params, paramName, parentId);
    return params;
}

function taxonomyAllSelected(facetId, categoryId, location) {
    var params = getSearchParams(location);
    var paramName = parameterNameFromFacetId(facetId);
    removeParamsFromList(params, paramName, categoryId);
    return params;
}

function modifyUrlWhenPageChanges(page, params) {
    var newParams = (0, _cloneDeep2.default)(params);
    var paramName = _paramTypes2.default.PAGE;
    if (page === 1) {
        delete newParams[paramName];
    } else {
        newParams[paramName] = page;
    }
    return newParams;
}

function removeCountryAndDistance(location) {
    var params = getSearchParams(location);
    removeCountry(params);
    removeDistance(params);
    return params;
}

function modifyUrlWithDistance(country, zipCode, range, measurement, location) {
    var params = getSearchParams(location);
    removeCountry(params);
    var paramName = _paramTypes2.default.DISTANCE_ID;
    params[paramName] = country + ':' + zipCode + ':' + range + ':' + measurement;
    return params;
}

function modifyUrlWithSort(sortOption, location) {
    var params = getSearchParams(location);
    var paramName = _paramTypes2.default.SORT;
    params[paramName] = sortOption;
    return params;
}

function removeFacetById(facetId, location) {
    var params = getSearchParams(location);
    var paramName = parameterNameFromFacetId(facetId);
    delete params[paramName];
    return params;
}

function removeFacetFromUrl(location, categoryId, params, baseUrl) {
    // expecting a url in the pattern of "/c/name/name/id/id", "/c/name/id" or "/c"
    var url = location.pathname;
    // split the current location into its separate parts
    var splitUrl = url.split('/');
    // remove the empty string and the c (created because of the format '/c/')from the array
    var categoryNames = splitUrl.splice(2, splitUrl.length - 2);
    // split the category names and Ids (there will always be an even number of Ids and names in the pattern name/id or name/name/id/id etc.)
    var categoryIds = categoryNames.splice(categoryNames.length / 2, categoryNames.length - categoryNames.length / 2);

    var id = '';
    var name = '';
    // begin reassembling the two parts by adding each of the ones we want but not the one we don't
    for (var i = 0; i < categoryIds.length; i += 1) {
        if (categoryIds[i] !== categoryId) {
            id += categoryIds[i] + '/';
            name += '/' + categoryNames[i];
        }
    }

    if (name === '') {
        var _url = baseUrl;
        if (!(0, _isEmpty2.default)(params)) {
            _url = (0, _urls.getCategoryUrlWithParams)(_url, params);
        }
        return _url;
    }

    return (0, _urls.getCategoryUrlWithParams)('/' + splitUrl[1] + name + '/' + id.substring(0, id.length - 1) + '/', params);
}

function removeUpcomingFacetFromUrl(location, categoryId, params) {
    return removeFacetFromUrl(location, categoryId, params, (0, _urls.getCategoryLandingPageBaseUrl)());
}

function removeArchiveFacetFromUrl(location, categoryId, params) {
    return removeFacetFromUrl(location, categoryId, params, (0, _urls.getPriceGuideBaseUrl)());
}

function clearAllParamsExceptCategoriesForCategoryPage(location, facets) {
    var categoryFacets = facets.filter(function (fac) {
        return fac.id === _facetTypes2.default.CATEGORY_ID;
    });
    var selectedCategoryFacet = [];
    if (categoryFacets.length) {
        selectedCategoryFacet = categoryFacets[0].categories.facets.filter(function (fac) {
            return fac.selected;
        });
    }
    // expecting a url in the pattern of "/c/name/name/id/id", "/c/name/id" or "/c"
    var url = location.pathname;
    // split the current location into its separate parts
    var splitUrl = url.split('/');
    // just gets the Id for the first category in the url
    var id = splitUrl[(splitUrl.length + 1) / 2];
    // just gets the name for the first category in the url
    var name = splitUrl[2];
    // if the length is 3 (meaning there's no categories in the url) or id is greater than or equal to the firstNonCategoryId (meaning it's a facet not a category)
    if (splitUrl.length <= 3 || selectedCategoryFacet.length <= 0) {
        return (0, _urls.getCategoryLandingPageBaseUrl)();
    }

    return '/' + splitUrl[1] + '/' + name + '/' + id;
}
function clearAllParamsExceptCategories(location, facets) {
    var params = getSearchParams(location);

    (0, _keys2.default)(params).forEach(function (key) {
        if (key === _paramTypes2.default.KEYWORD || key === _paramTypes2.default.PAGE || key === _paramTypes2.default.PAGE_SIZE_LEGACY_SUPPORT || key === _paramTypes2.default.PAGE_SIZE || key === _paramTypes2.default.SORT || key === _paramTypes2.default.STATUS) return;

        if (key === _paramTypes2.default.CATEGORY_ID) {
            var categoryFacets = facets.filter(function (fac) {
                return fac.id === _facetTypes2.default.CATEGORY_ID;
            });
            var selectedCategoryFacet = categoryFacets[0].categories.facets.filter(function (fac) {
                return fac.selected;
            });
            if (selectedCategoryFacet.length > 0) {
                params[key] = selectedCategoryFacet[0].id;
            } else {
                delete params[key];
            }
        } else {
            delete params[key];
        }
    });
    return params;
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/searchParams.js
// module id = MJ4I
// module chunks = 60